import App from "@/App.vue"
import Admin from "@/layouts/Admin.vue"
import Default from "@/layouts/Default.vue"
import "@/plugins/axios"
import "@/plugins/meta"
import vuetify from "@/plugins/vuetify"
import "@/registerServiceWorker"
import router from "@/router"
import store from "@/store"
import Vue from "vue"
import VueMasonry from "vue-masonry-css"
import VueDraggable from "vuedraggable"

Vue.config.productionTip = false

Vue.use(VueMasonry)
Vue.component("draggable", VueDraggable)
Vue.component("default-layout", Default)
Vue.component("admin-layout", Admin)

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount("#app")
